export default class Campaign {
  constructor(id, priority, url) {
    this.id = id;
    this.priority = priority * 1;
    this.url = url;
  }
}
